import { has, Props } from "wasabi-common";
import Tree from "wasabi-common/lib/collection/Tree";
import Strings from "wasabi-common/lib/types/Strings";

export class TemplateString {
  private value: string;

  public constructor(value: string) {
    this.value = value;
  }

  public toString(props?: Props) {
    if (!props) {
      return this.value.toString();
    }
    return Strings.template(this.value, props);
  }
}

export class Language extends Tree<string> {
  public value(...keys: any[]): string {
    Language.wrapKeys(keys);
    return super.value.apply(this, keys);
  }

  public tree(...keys: any[]): Language {
    Language.wrapKeys(keys);
    return new Language(this.get.apply(this, keys));
  }

  public find(...keys: any[]): TemplateString {
    Language.wrapKeys(keys);
    const value = this.value.apply(this, keys);
    if (!has(value)) {
      return new TemplateString("");
    }
    return new TemplateString(String(value));
  }

  private static wrapKeys(keys: any[]) {
    if (keys) {
      for (let i = 0; i < keys.length; i = i + 1) {
        const key = keys[i];
        if (typeof key === "number") {
          keys[i] = `${key}`;
        }
      }
    }
  }
}

const language = new Language();

export default language;
